<div class="template-selector">
  @if (isLoading()) {
    <p class="template-selector__status">
      {{
        "use-case-wizard.template-selector.status.loading-templates" | translate
      }}
    </p>
  } @else if (isError()) {
    <p class="template-selector__status template-selector__status--error">
      {{
        "use-case-wizard.template-selector.status.failed-to-load-templates"
          | translate
      }}
    </p>
  } @else {
    <div class="template-selector__grid">
      @for (template of templates(); track template.id) {
        <button
          type="button"
          class="template-card"
          [class.template-card--selected]="selectedId === template.id"
          (click)="select(template)"
        >
          <span class="template-card__figure">
            @if (template.image) {
              <img
                class="template-card__image"
                [src]="template.image"
                [alt]="title(template)"
              />
            } @else {
              <span class="template-card__image-placeholder"></span>
            }
          </span>
          <span class="template-card__title">{{ title(template) }}</span>
          @if (template.description) {
            <span class="template-card__description">{{
              template.description
            }}</span>
          }
        </button>
      } @empty {
        <p class="template-selector__status">
          {{
            "use-case-wizard.template-selector.status.no-templates-available"
              | translate
          }}
        </p>
      }
    </div>
  }
</div>
